import api from "./api";

const NotificationAPI = {
    getByUserId: (statusId) => api.get(`/notifications/read-status/${statusId}`),
    getUserSettings: (userId) => api.get(`/notifications/user-settings/${userId}`),
    insUpdUserSetting: (data) => api.post(`/notifications/user-settings`, data),
};

export default NotificationAPI;